const SUBDOMAIN = window.location.hostname.split(".")[0];

const FAVICON_MAP: Record<string, string> = {
  precision: "favicon-precision.ico",
  thermocloud: "favicon-thermocloud.ico",
};

const TITLE_MAP: Record<string, string> = {
  precision: "Precision Smart Metering",
  thermocloud: "ThermoCloud",
};

const DEFAULT_FAVICON = "favicon.ico";
const DEFAULT_TITLE = "Atom PRO";

export const setFavicon = () => {
  const faviconHref = FAVICON_MAP[SUBDOMAIN] || DEFAULT_FAVICON;
  const faviconEl = document.getElementById(
    "favicon"
  ) as HTMLLinkElement | null;
  faviconEl?.setAttribute("href", `/${faviconHref}`);
};

export const setTitle = () => {
  document.title = TITLE_MAP[SUBDOMAIN] || DEFAULT_TITLE;
};
